module.exports = __webpack_public_path__ + "img/poster_011.b38c2da1.png";